<template>
    <div class="factors">
        <dataTable :headers="headers" :items="tableItems" :itemsPerPage="9999" hideFooter>
            <template v-slot:item="{ item, index }">
                <tr :class="`state-${getConfigValue(item.FieldId)}`">
                    <td class="factor-info">
                        <p class="subtitle-2">{{ item.Label }}</p>
                        <p class="body-2">{{ item.Description }}</p>
                    </td>
                    <td>
                        <div class="status">
                            <configField :id="ruleId" :field="item" :category="category" :index="index"
                                :value="getConfigValue(item.FieldId)" :rules="validationRules"
                                @setConfigValue="setConfigValue" emitSetConfig hideLabel />
                            <p class="subtitle-1">{{ getConfigValue(item.FieldId) ? 'Enabled' : 'Disabled' }}</p>
                        </div>
                    </td>
                </tr>
            </template>
        </dataTable>
    </div>
</template>
<script>
import dataTable from "@/qux-common/qux22/components/organisms/data-table";
import getValidationRules from "@/util/getValidationRules";
import fieldMap from "./field-map.json";
import { mapGetters } from "vuex";

export default {
    name: "FactorsField",
    components: {
        dataTable,
        configField: () => import("../config-field"),
    },
    props: {
        availableFieldList: {
            type: Array,
        },
        category: {
            type: String,
        },
        id: {
            type: String,
        },
        label: {
            type: String,
        },
        rules: {
            type: Array,
        },
        ruleId: {
            type: String,
        },
        value: {
            type: [String, Object, Number, Boolean, Array],
        },
        parentField: {
            type: String,
        },
    },
    data() {
        return {
            headers: [
                {
                    "text": "Factors",
                    "key": "factor",
                    "sortable": false
                },
                {
                    "text": "Active Status",
                    "key": "value",
                    "sortable": false
                }
            ]
        };
    },
    methods: {
        getConfigValue(id) {
            return (
                this.mergedConfig[this.ruleId] &&
                this.mergedConfig[this.ruleId][this.category] &&
                this.mergedConfig[this.ruleId][this.category][this.id] &&
                this.mergedConfig[this.ruleId][this.category][this.id][id]
            );
        },
        setConfigValue(value) {
            let valueObject = {};
            valueObject[value.fieldId] = value.value;
            this.$emit("setConfigValue", valueObject);
        },
        getFieldValue(value, id = this.id) {
            return (
                fieldMap[this.category] &&
                fieldMap[this.category][id] &&
                fieldMap[this.category][id][value]
            );
        },
        getFieldIsVisible(field) {
            const visible =
                this.configVisibility[this.ruleId] &&
                this.configVisibility[this.ruleId][this.category] &&
                this.configVisibility[this.ruleId][this.category][field.FieldId];
            return (visible);
        },
    },
    computed: {
        tableItems() {
            let theResult = [];
            for (const currItem of this.availableFieldList) {
                const appliesTo =
                    fieldMap[this.category] &&
                    fieldMap[this.category][currItem.FieldId] &&
                    fieldMap[this.category][currItem.FieldId]["appliesTo"];
                if (appliesTo) {
                    currItem.appliesTo = appliesTo;
                }
                if (this.getFieldIsVisible(currItem)) {
                    theResult.push(currItem);
                }
            }
            return theResult;
        },
        validationRules() {
            return getValidationRules({
                rules: this.rules,
                inputErrorMessage: this.getFieldValue("inputErrorMessage"),
            });
        },
        ...mapGetters({
            configVisibility: "getConfigVisibility",
            mergedConfig: "getMergedConfig",
        }),
    },
};
</script>


<style lang="scss" scoped>
.factors {
    margin-bottom: $qvo-spacing-24;

    p.label {
        margin-bottom: $qvo-spacing-24;
    }

    .v-data-table {
        &::v-deep {
            .factor-info {
                opacity: 1;
                transition: opacity 0.3s ease;
            }

            .state-false,
            .state-undefined {
                .factor-info {
                    opacity: 0.5;
                }
            }

            .config-field .v-input--selection-controls {
                margin-top: 0;
            }
        }
    }
}



.status {
    height: 100%;
    display: flex;
    align-items: center;
    gap: $qvo-spacing-8;
}
</style>